<a class="text-decoration-none"
   [routerLink]="[appRoutes.root, appRoutes.ad, data.adId]">
  <div class="rounded-3 card border shadow overflow-hidden">
    <div class="image-container">
      <nz-image
        [imageUrl]="data.imageUrl"
        [imageAlt]="'Обява: ' + data.title">
      </nz-image>
    </div>
    <div class="mt-3 mb-2 text-center text-primary-emphasis">
      @if (data.adType === AdTypeEnum.DirectSale) {
        <i class="fa-solid fa-shopping-cart"></i>
      } @else if (data.adType === AdTypeEnum.Auction) {
        <i class="fa-solid fa-gavel"></i>
      }
      <strong class="ms-2">{{ data.price }} лв.</strong>
    </div>
    <div class="mx-2 small fw-medium ad-title card-title text-center">{{ data.title }}</div>
  </div>
</a>
